/* eslint-disable */
import errorHandler from '../../utils/errorHandler'
import {bus} from '../../utils/bus'
// import md5 from 'js-md5'

/* *********
 请求方法
 ********* */
export const delete_ = (url, data) => _myFetch('DELETE', url, data)

export const patch = (url, data) => _myFetch('PATCH', url, data)

export const post = (url, data) => _myFetch('POST', url, data)

export const get = (url) => _myFetch('GET', url)

export const addRequestBody = (url, requestBody) => {
  return `${url}&${
    Object.entries(requestBody)
      .filter(([key, value]) =>
        !['pageNum', 'pageSize'].includes(key) &&
        ![undefined, null].includes(value)
      )
      .map(([key, value]) => `${key}=${value}`)
      .join('&')
    }`
}

/* *********
 返回结果处理函数
 ********* */
export const ifNotOkReject = response =>
  response.ok === true
    ? Promise.resolve(response)
    : Promise.reject(response)

export const ifOkToJson = response =>
  response.ok === true
    ? Promise.resolve(response.json())
    : Promise.reject(response)

export const getData = res =>
  res.retCode == 1
    ? res.data
    : Promise.reject(res.data)

export const isDataFine = res => res['retCode'] == 1 || Promise.reject(res)

/* *********
 私有方法
 ********* */

const _myFetch = (method, url, data) => {
  let timestamp = new Date().getTime()
  // let sendUrl
  // if (url.indexOf('?') !== -1) {
  //   sendUrl = `/ecard${url.split('ecard')[1].split('?')[0]}`
  // } else {
  //   sendUrl = `/ecard${url.split('ecard')[1]}`
  // }
  // let allowToken = `url=${sendUrl}&timestamp=${timestamp}&key=WLXXPBDBVDZYONRQW7P9XRTJFI1NXCKA`
  // let accessToken = md5(allowToken)
  return _fetch(
    url, {
      method,
      headers: {
        'Content-Type': 'application/json',
        'kj-type': 'gy',
        'yq-app-code': bus.global.yqCode,
        'token': bus.global.token
        // 'sign': accessToken
      },
      body: JSON.stringify(data)
    }, timestamp)
}

const _fetch = function withAuthFetch (...args) {
  // const url = args[0]
  // let timestamp = args[2]
  // if (!timestamp) {
  //   timestamp = new Date().getTime()
  // }
  // args[0] = `${addToken(url)}&timestamp=${timestamp}`

  const promise = fetch(...args)
  promise.catch(errorHandler('无法访问服务器'))

  return promise.then(res => {
    if (res.status === 400) {
      res.json().then(errorHandler('请求失败'))
    }
    // if (res.status === 401 || res.status === 403) {
    //   return Promise.reject(res)
    // }
    return res
  })
}



// WEBPACK FOOTER //
// ./src/view/api/index.js